import { render, staticRenderFns } from "./NuevoAsistencia.vue?vue&type=template&id=68e16892&scoped=true"
import script from "./NuevoAsistencia.vue?vue&type=script&lang=js"
export * from "./NuevoAsistencia.vue?vue&type=script&lang=js"
import style0 from "./NuevoAsistencia.vue?vue&type=style&index=0&id=68e16892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e16892",
  null
  
)

export default component.exports